import { defineStore } from "pinia";
import store from "./index";
import { cloneDeep } from "lodash-es";
import { times } from "@/utils/mathUtil";
import { Persistent } from "@/utils/cache/persistent";
import { useShopStoreWithOut } from "./shopStore";
import { isArray } from "@/utils/isUtil";

const CART_KEY = "__CART__";

export const useCartStore = defineStore({
  id: "cart",
  state: () => {
    return {
      cart: [],
      // 选中的优惠券
      coupon: null,
      // 远程获取到的礼品卡
      voucherCodeDetail: null,
      // 选中的礼品卡，结构同voucherCodeDetail，多一个_selectTime
      voucherCode: null,
      // 选中的积分，结构同points_payment_rule，多一个_selectTime
      points: null,
    };
  },
  getters: {
    getCart(state) {
      return state.cart;
    },
    getCartLength(state) {
      return state.cart.length;
    },
    getCartTotalDishNum(state) {
      return state.cart.reduce((pre, dish) => {
        return (pre += dish.num);
      }, 0);
    },
    getCartTotalPrice(state) {
      return state.cart.reduce((pre, dish) => {
        return (pre += times(dish.selectedPrice, dish.num));
      }, 0);
    },
    getCartItemCurrency(state) {
      return state.cart[0]?.currency;
    },
    // 获取选中的优惠券信息
    getCoupon(state) {
      return state.coupon;
    },
    // 获取从远程获取到的礼品卡
    getVoucherCodeDetail(state) {
      return state.voucherCodeDetail;
    },
    // 获取选中的礼品卡信息
    getVoucherCode(state) {
      return state.voucherCode;
    },
    // 获取选中的积分信息
    getPoints(state) {
      return state.points;
    },
  },
  actions: {
    setCart(cart) {
      if (isArray(cart)) {
        this.cart = cart;
      }
    },
    addItem(dishItem) {
      const sameShoppingCartItemIndex = this.cart.findIndex(
        (item) => item.UUKey === dishItem.UUKey
      );
      if (sameShoppingCartItemIndex === -1) {
        // 加购物车
        this.cart.push(cloneDeep(dishItem));
      } else {
        // 改变购物车已有item的数目
        const cartItem = this.cart.find(
          (item) => item.UUKey === dishItem.UUKey
        );
        this.changeNum(sameShoppingCartItemIndex, cartItem.num + dishItem.num);
      }
    },
    changeNum(index, num) {
      if (num <= 0) {
        this.deleteItemByIndex(index);
      } else if (num <= 99) {
        this.cart[index].num = num;
      }
    },
    deleteItemByIndex(delIndex) {
      this.cart.splice(delIndex, 1);
    },
    clear() {
      this.cart.splice(0, this.cart.length);
    },
    // 选中优惠券
    setCoupon(coupon) {
      this.coupon = coupon;
    },
    // 把从远程获取到的礼品卡保存到cartStore
    setVoucherCodeDetail(voucherCodeDetail) {
      this.voucherCodeDetail = voucherCodeDetail;
    },
    // 选中礼品卡
    setVoucherCode(voucherCode) {
      this.voucherCode = voucherCode
        ? {
            ...voucherCode,
            _selectTime: Date.now(),
          }
        : null;
    },
    // 选中积分
    setPoints(points) {
      this.points = points
        ? {
            ...points,
            _selectTime: Date.now(),
          }
        : null;
    },
    setCartStorage() {
      const shopStore = useShopStoreWithOut();
      Persistent.setSession(CART_KEY, {
        shop_id: shopStore.getShopId,
        cart: this.cart,
      });
    },
    getCartStorage() {
      return Persistent.getSession(CART_KEY);
    },
    removeCartStorage() {
      Persistent.removeSession(CART_KEY);
    },
  },
});

export function useCartWithOut() {
  return useCartStore(store);
}
